import { createIcon, Path } from './index';

export const IconCoins = createIcon({
  title: 'Two overlapping coins.',
  viewBox: '0 0 32 32',
  path: [
    <Path
      d="M10.667 18.6667C15.0853 18.6667 18.667 15.085 18.667 10.6667C18.667 6.24841 15.0853 2.66669 10.667 2.66669C6.24871 2.66669 2.66699 6.24841 2.66699 10.6667C2.66699 15.085 6.24871 18.6667 10.667 18.6667Z"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M24.1204 13.8267C25.3809 14.2966 26.5024 15.0767 27.3814 16.0949C28.2605 17.1131 28.8685 18.3366 29.1494 19.6521C29.4303 20.9676 29.375 22.3327 28.9885 23.6211C28.602 24.9096 27.8969 26.0798 26.9383 27.0235C25.9798 27.9672 24.7987 28.654 23.5044 29.0203C22.2101 29.3866 20.8443 29.4207 19.5334 29.1193C18.2224 28.8179 17.0086 28.1908 16.0042 27.296C14.9998 26.4012 14.2373 25.2676 13.7871 24"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M9.33301 8H10.6663V13.3333"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M22.2798 18.5067L23.2131 19.4533L19.4531 23.2133"
      fill="none"
      stroke="#35405F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
